import * as Sentry from "@sentry/react";

/**
 * Configure Sentry for error tracking and performance monitoring.
 * Only initializes in production builds to avoid noise during development.
 *
 * @returns
 */
export function initSentry(): void {
  if (!import.meta.env.PROD) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 0.1, // Capture 10% of transactions to stay within rate limits
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "klodus.follosoft.com"],
    // Session Replay
    replaysSessionSampleRate: 0.05, // 5% of sessions
    replaysOnErrorSampleRate: 0.5, // 50% of error sessions
  });
}
